module.exports = __webpack_public_path__ + "img/10-02_Motivating People.c91ac150.svg";